import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=48e11dbb&scoped=true&"
import script from "./Wysiwyg.vue?vue&type=script&lang=js&"
export * from "./Wysiwyg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e11dbb",
  null
  
)

export default component.exports